export const ClassroomSeatingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" rx="6" fill="url(#pattern0_8315_4762)" />
      <defs>
        <pattern
          id="pattern0_8315_4762"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_8315_4762" transform="scale(0.0434783)" />
        </pattern>
        <image
          id="image0_8315_4762"
          width="23"
          height="23"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAIAAABvSEP3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATlJREFUeNpiVFFSYWZhYaAAfPv6jYWLm4uNnY0SU379+MnEQA0wCE2RlJTctGnTvn377O3tgdyenp7Tp08XFRURI4swxdfXF6iUl5c3MjISyICoBrIhsg4ODnhkEaZs3rz58+fPQMbBgwefP39+69YtCBsie+DAATyyQMCop6sHjGmgDVJSUpgePnv2LMRHeGTfvnrLAvdRamoqpjpTU1OCsgi3UBJBQLcMpvTCLC4uzszCDIk5KysrYPj/+vULGJfu7u7AeHn79i1EHR7Z71+/MwDDxcTEpKGh4T8YACPV0dERwv706ZMJGOCXVZRTpI6PoDG9ZcsWIAlMFMuXLwc6NSMjw9jYGGgzMbKImPYBA0xLgBqAJH5ZRKoDputz587hcjB+2WGZ6liAJfjPn78oMeLP378AAQYA0q/VfOMhTPAAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};
